import { render, staticRenderFns } from "./NCard.vue?vue&type=template&id=3bae5890&scoped=true&"
import script from "./NCard.vue?vue&type=script&lang=js&"
export * from "./NCard.vue?vue&type=script&lang=js&"
import style0 from "./NCard.vue?vue&type=style&index=0&id=3bae5890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae5890",
  null
  
)

export default component.exports